import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-home-dashboard',
  templateUrl: './home-dashboard.component.html',
  styleUrls: ['./home-dashboard.component.scss'],
})
export class HomeDashboardComponent implements OnInit {
  constructor(private router: Router, private route: ActivatedRoute) {}

  ngOnInit(): void {}

  openMarketExpansion() {
    this.router.navigate(['/expansion'] , {relativeTo: this.route})
  }

  openMecsFootPrint() {
    this.router.navigate(['/specs'], {relativeTo: this.route})
  }
}
